import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: 'https://customer-offers.preprd-apps.enelx.com/v1',
      globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
      baseUrlV2: 'https://customer-offers.preprd-apps.enelx.com/v2'
    }
  },
  cdn: 'https://cdn.preprd-apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US'
  }
};
